export function loadJs(src: string, onLoad?: () => void, onError?: (event: any) => void): void {
  // eslint-disable-next-line prefer-destructuring
  const body = document.getElementsByTagName('body')[0];
  const tag = document.createElement('script');

  tag.type = 'text/javascript';
  tag.async = false;

  const handleLoad = (): void => onLoad?.();
  const handleReject = (event: any): void => onError?.(event);

  tag.addEventListener('load', handleLoad);
  tag.addEventListener('error', handleReject);

  tag.src = src;
  body.appendChild(tag);
}
